export default __webpack_public_path__ + "static/media/sharif.38d63f05.png";